import axiosInstance from "../apis/axiosInstance";
import { encryptData } from '../apis/cryptoUtils';

export const webAuth = async () => {

  const authData = {
    uname: encryptData(import.meta.env.VITE_WEB_LOGIN_UNAME),
    pass: encryptData(import.meta.env.VITE_WEB_LOGIN_PASS),
    secretkey: encryptData(import.meta.env.VITE_LOGIN_SECRET_KEY),
  };
  
  try {
    const loginResponse = await axiosInstance.post("/backend/user/web-auth", authData);
    const loginResponseData = loginResponse.data;

    if (loginResponse.status !== 200) {
      throw new Error(loginResponseData.message || "Failed to login");
    }
 
    const token = loginResponseData.token;

    if (!token) {
      // console.error("Token not received after login:", loginResponseData);
      throw new Error("Token not received after login");
    }

    const cookieResponse = await axiosInstance.post("/backend/user/store-token", { token });

    // Return the data you need. For example:
    return {loginResponse: loginResponse, cookieResponse: cookieResponse};

  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Something went wrong" };
  }
};
